globalThis = typeof window !== 'undefined' ? window : global;